export const navigationItems = [
  {
    title: "Solutions",
    path: "/#solutions",
    children: [
      {
        title: "Engagement Surveys",
        path: "/solutions/pulse",
        icon: "heart",
        description: "Listen to your people and enable data driven leadership",
      },
      {
        title: "Personal Feedback",
        path: "/solutions/feedback",
        icon: "hand",
        description: "Fuel personal development and create engagement",
      },
      {
        title: "Performance Management",
        path: "/solutions/performance-management",
        icon: "chart",
        description:
          "Lean and fair performance reviews in Slack or Microsoft Teams",
      },
      {
        title: "Organizational Network Analysis",
        path: "/solutions/organizational-network-analysis",
        icon: "statistics",
        description:
          "Understand what’s really happening and who are at the center of it",
      },
      {
        title: "Anonymous Chat",
        path: "/solutions/anonymous-chat",
        icon: "phone",
        description: "Become “Whistleblower Directive” compliant in 5 minutes",
      },
    ],
  },
  { title: "Pricing", path: "/pricing" },
  {
    title: "Resources",
    path: "/blog",
    children: [
      {
        title: "Blog",
        path: "/blog",
        icon: "star",
        description: "Best practices and insights in the HR tech industry",
      },
      {
        title: "About Us",
        path: "/about",
        icon: "heart",
        description: "Teamspective mission and company values",
      },
    ],
  },
  {
    title: "Case Studies",
    path: "/case-studies",
    icon: "heart",
    description: "Discover case studies of Teamspective customers",
  },
  //  { title: "Community", path: "/community" },
]
